import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { AuthGuardService } from './shared/service/auth-guard/auth-guard.service';
import { ForbiddenComponent } from './view/error/forbidden/forbidden.component';
import { LoginComponent } from './view/login/login.component';
import { LogoutComponent } from './view/logout/logout.component';

const routes: Routes = [
  {
    path: 'error/forbidden',
    component: ForbiddenComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'shared/dashboard/:token',
    loadChildren: () => import('./view/device-dashboard/device-dashboard.module').then((m) => m.DeviceDashboardModule),
    data: { isReadOnly: true },
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () => import('./view/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'device-management',
        loadChildren: () =>
          import('./view/device-management/device-management.module').then((m) => m.DeviceManagementModule),
      },
      {
        path: 'device-dashboard',
        loadChildren: () =>
          import('./view/device-dashboard/device-dashboard.module').then((m) => m.DeviceDashboardModule),
      },
      {
        path: 'device-last-message',
        loadChildren: () =>
          import('./view/device-last-message/device-last-message.module').then((m) => m.DeviceLastMessageModule),
      },
      {
        path: 'device-command-schedule',
        loadChildren: () =>
          import('./view/device-command-schedule/device-command-schedule.module').then(
            (m) => m.DeviceCommandScheduleModule,
          ),
      },
      {
        path: 'firmware-manager',
        loadChildren: () =>
          import('./view/firmware-manager/firmware-manager.module').then((m) => m.FirmwareManagerModule),
      },
      {
        path: 'user-management',
        loadChildren: () => import('./view/user-management/user-management.module').then((m) => m.UserManagementModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
